import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "trixEditor"]

  connect() {
    this.updateFields()
    this.checkValidity()

    // Listen for changes on normal fields
    this.normalFields.forEach(field => {
      field.addEventListener("input", () => this.checkValidity())
    })

    // Listen for changes on Trix editors
    if (this.hasTrixTarget) {
      this.trixEditorTarget.addEventListener("trix-change", () => this.checkValidity())
    }

    // Optional: handle initial delay for Trix to initialize
    setTimeout(() => this.checkValidity(), 100)
  }

  updateFields() {
    // All required fields excluding hidden trix-inputs
    this.normalFields = Array.from(
      this.element.querySelectorAll(
        "input[required]:not(.trix-input):not([type='hidden']), textarea[required], select[required]"
      )
    )
  }

  checkValidity() {
    const normalValid = this.normalFields.every(field => field.value.trim() !== "")

    let trixValid = true;

    if (this.hasTrixTarget) {
      const inputId = this.trixEditorTarget.getAttribute("input")
      const input = document.getElementById(inputId)
      trixValid = input && input.value.trim() !== ""
    }

    this.submitButtonTarget.disabled = !(normalValid && trixValid)
  }
}
